import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const createLinearTicket = {
  name: "createLinearTicket" as const,
  input: z.object({ clusterId: zExt.objectId() }),
  output: z.object({
    success: z.boolean(),
    ticketId: z.string().optional(),
    ticketUrl: z.string().optional(),
  }),
};
